var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvif(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      enableBackground: "new 0 0 760 568"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "470.5,567.31 0.47,284 470.5,0.69   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "470.5,567.31 356.27,466.45 470.5,414.65   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "356.27,101.55 470.5,0.69 470.5,153.35   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "759.53,284 356.27,466.45 356.27,101.55   "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M189.48,294.52h-24.31l12.16-41.96L189.48,294.52z M246.02,344.09l-45.31-130.19h-46.78l-45.31,130.19h42.18l4.42-15.22    h44.2l4.42,15.22H246.02z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "309.28,344.09 354.59,213.91 312.41,213.91 285.89,301.54 259.37,213.91 217.19,213.91 262.5,344.09   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "459.92,344.09 459.92,295.49 514.62,295.49 514.62,261.14 459.92,261.14 459.92,248.26     515.91,248.26 515.91,213.91 422.71,213.91 422.71,344.09   "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.33,
    y: 213.91,
    className: "st3",
    width: 37.2,
    height: 130.19
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvif);
export default __webpack_public_path__ + "static/media/Avif.b0f622a4e9476ebb3838a78db38cd7ad.svg";
export { ForwardRef as ReactComponent };